import React, { InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '../../../shared/lib/utils';
import { Typography } from '../Typography/Typography';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  error?: string;
  fullWidth?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      error,
      fullWidth,
      id,
      ...props
    },
    ref,
  ) => {

    return (
      <div className={cn('w-auto', (fullWidth && 'flex-1'))}>
        <input
          className={cn(
            'normal font-[400] h-11 rounded-3xl px-3 bg-[#0000000D] w-full text-[var(--black-grey)] focus:outline-none',
            className,
          )}
          {...props}
        />
        {error && (
          <Typography
            tag='caption'
            className='text-red-700 ml-3'
          >
            {error}
          </Typography>
        )}
      </div>
    );
  },
);

Input.displayName = 'Input'; 